<template>
  <div>
    <Form
      page-title="Add a new Service"
      buttonName="Submit"
      :isCreateMode="true"
      :isInList="isInList"
      @submit="submit"
      ref="ServicesForm"
      :loading="loading"
    />
  </div>
</template>
<script>
import Form from "./Form";
import { createService } from "@/API/ServicesAPIs";
import { submitAndNotify } from "@/helpers/utils";
export default {
  name: "Create",
  props: ["isInList"],
  components: { Form },
  data() {
    return {
      loading: false
    };
  },
  methods: {
    async submit(formData) {
      const callback = () => {
        this.$refs.ServicesForm.resetForm();
      };
      submitAndNotify(this, createService(formData), callback);
    }
  }
};
</script>
<style></style>
